import { translateTemplateLevelText, translateTemplateText } from '@focuslee/shared-mini-app';
import { Box, Stack } from '@mui/material';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ListAchievement } from '../../client/types';
import { getAchievementLevelProgress } from '../../helpers/achievement';
import { dateSorterGeneric, formatAchievementDate } from '../../helpers/datetime';
import { AchievementItem } from './AchievementItem';
import { AchievementItemEmpty } from './AchievementItemEmpty';

type AchievementsLatestViewProps = {
  achievements: ListAchievement[];
  onAchievementClick?: (id: string) => void;
}

export const LatestAchievementsView: FC<AchievementsLatestViewProps> = ({achievements, onAchievementClick} : AchievementsLatestViewProps) => {
  const { t } = useTranslation();
  const lastThreeAchievements = [
      ...achievements
      .filter(a => a.achievedOn)
  ]
  .sort((a, b) => dateSorterGeneric(a, b, i => i.achievedOn, false))
  .slice(0, 3);

  return (
    <Box px={2} sx={{ flexShrink: 0, mt: '16px', mb: '28px' }}>
      <Stack direction="row" spacing={4} height={150}>
        {lastThreeAchievements.map((achievement) => {
          const achievementLevelProgress = getAchievementLevelProgress(achievement);
          const level = achievementLevelProgress?.achievementLevels?.[Math.max(achievementLevelProgress.currentLevel - 1, 0)];
          const levelIndex = achievementLevelProgress ? Math.max(achievementLevelProgress.currentLevel - 1, 0) : null;
          return (
            <AchievementItem
              key={achievement.id}
              icon={achievement.icon}
              title={level
                ? translateTemplateLevelText(t, achievement.templateId, levelIndex, 'name', level.name)
                : translateTemplateText(t, achievement.templateId, 'name', achievement.name)}
              timeAgo={formatAchievementDate(achievement.achievedOn)}
              rarity={achievement.rarity}
              iconImageColor={level?.iconImageColor ?? achievement.iconImageColor}
              iconImageUrl={level?.iconImageUrl ?? achievement.iconImageUrl}
              onClick={onAchievementClick ? () => onAchievementClick(achievement.id) : undefined}
            />
          );
        })}
        {Array.from({ length: 3 - lastThreeAchievements.length }).map((_, index) => (
          <AchievementItemEmpty key={index} />
        ))}
      </Stack>
    </Box>
  );
}
